import * as React from "react";
import AnchorButton from "../../components/AnchorButton";
import { oneLink } from "../../shared/oneLink";
import { MainLayout } from "../../components/Layout";

const IncompleteRegisterPage = (): JSX.Element => {
    return (
        <MainLayout>
            <section className="to-payment-make">
                <div className="to-apple-subscription-stop-strong">
                    <h3 className="not-paid-member-label">
                        登録が完了していません。
                        <br />
                        アプリを開いて登録を完了させてください。
                    </h3>
                </div>
                <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
            </section>
        </MainLayout>
    );
};

export default IncompleteRegisterPage;
